{
  "sdk-download-android": "Descargar para Android",
  "sdk-connect": "Conectar",
  "sdk-download-ios": "Descargar para iOS",
  "sdk-install": "Instalar",
  "sdk-modal-instruct-1": "1. Open Binance app",
  "sdk-modal-instruct-2": "2. Pulsa en {{icon}} en la página principal",
  "sdk-modal-title": "Connect With Binance",
  "sdk-no-app": "¿Aún no tienes la aplicación de Binance?"
}